/* tslint:disable */
/* eslint-disable */
export enum UnitOfLength {
  Mm = 'mm',
  Cm = 'cm',
  M = 'm',
  Inch = 'inch'
}
